import { styled } from "styled-components";
import { Outlet } from "react-router-dom";

export default function AllProjects() {
  return (
    <Container className="wrap">
      <div className="block-space" />
      <Outlet />
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  flex: 1;
  min-height: 0;
`;
